import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
export var VILLAGE_SUGGEST_FIELD = {
  field: {
    label: 'Наименование коттеджного поселка',
    name: EFormFieldsNames.VillageId,
    type: EExtendedFieldTypes.VillageSuggestField,
    required: false
  },
  validation: yup.number()
};